import assign from 'lodash.assign';
export class Address {
    constructor(init) {
        assign(this, init);
    }
    id;
    addressTypeCode;
    addressFormatCode;
    postbox;
    floor;
    room;
    streetName;
    additionalStreetName;
    blockName;
    buildingName;
    buildingNumber;
    inhouseMail;
    department;
    markAttention;
    markCare;
    plotIdentification;
    citySubdivisionName;
    cityName;
    postalZone;
    countrySubentity;
    countrySubentityCode;
    region;
    district;
    timezoneOffset;
    addressLines;
    country;
    locationCoordinates;
}
